import React, { useEffect, useState } from 'react'
import Switch from 'react-bootstrap/esm/Switch'
import { Redirect, Route, useLocation } from 'react-router-dom'
import { SelectHuyen } from '../shared/selecthuyen/SelectHuyen'
import { Menu } from './menu/Menu'
import './PublicBanDo.css'
import $ from 'jquery';
import { BaoCaoChuyenDeDat } from './baocao/BaoCaoChuyenDeDat'
import { SoLieu } from './baocao/SoLieu'

export const PublicSoLieu = () => {

    const [huyen, setHuyen] = useState({ value: 0 });
    const [filter, setFilter] = useState('');
    const [keyword, setKeyword] = useState('');

    const [printMap, setPrintMap] = useState(0);

    const getIdHuyen = async (huyen) => {
        setFilter('');
        setHuyen(huyen);
    }
    const onPrint = () => {
        setPrintMap(printMap + 1);
    }

    const timKiem = () => {
        setKeyword(filter);
    }

    function onChangeFilter(e) {
        setFilter(e.target.value);
    }
    const localtion = useLocation();
    useEffect(() => {
        $('a.nav-link').each(function (index) {
            if (!$(this).hasClass('collapsed')) {
                $(this).addClass('collapsed')
            }
        });
        $('div.collapse').each(function () {
            if ($(this).hasClass('show')) {
                $(this).removeClass('show')
            }
        });
    }, [localtion.pathname]);

    return (
        <div id="wrapper" className="public">
            <Menu></Menu>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-1 static-top shadow">
                        <div className="col-md-4">
                            <SelectHuyen onChangeHuyenProps={(e) => getIdHuyen(e)}></SelectHuyen>
                        </div>
                        <div className="input-group col-md-4">
                            <input type="text" className="form-control" placeholder="Tìm kiếm" value={filter} onChange={onChangeFilter} />
                            <div className="input-group-append">
                                <button className="btn btn-info" type="button" onClick={timKiem}><i className='fas fa-search'></i> Tìm kiếm</button>
                            </div>
                        </div>
                    </nav>
                    <div className="container-fluid">
                        <Switch>
                            <Route exact path="/public/solieu/">
                                <Redirect to="/public/solieu/solieudatdai"></Redirect>
                            </Route>
                            <Route path="/public/solieu/solieudatdai">
                                <SoLieu huyen={huyen} keyword={keyword}></SoLieu>
                            </Route>

                            {/* <Route path="/public/solieu">
                                <SoLieu huyen={huyen} keyword={keyword}></SoLieu>
                            </Route> */}


                        </Switch>
                    </div>
                </div>
                <footer className="sticky-footer bg-white">
                    <div className="container my-auto">
                        <div className="copyright text-center my-auto">
                            <span>Copyright © 2020</span>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    )
}
